// @owners { team: patients-team }
import autobind from 'autobind-decorator';
import React, { PureComponent } from 'react';
// eslint-disable-next-line import/no-deprecated
import { clearCreateSurveyResponseError, submitSurveyResponse } from '~shared/actions/surveyResponses';
import { connect } from '~shared/store';
import { type ReduxStateShared } from '~shared/types';
import SurveyPage, { type FormValues, type Question } from './SurveyPage';

const CES_QUESTIONS = [
  {
    order: 1,
    question: 'Alto made it easy to schedule my prescription(s) for delivery.',
    required: true,
    response: null,
    type: 'numeric',
  },
  {
    order: 2,
    question: 'Alto clearly and promptly notified me of my prescription(s).',
    required: false,
    response: null,
    type: 'numeric',
  },
  {
    order: 3,
    question: 'Alto made it easy to sign up.',
    required: false,
    response: null,
    type: 'numeric',
  },
  {
    order: 4,
    question: 'Alto made it easy to find and understand the details of my prescription(s).',
    required: false,
    response: null,
    type: 'numeric',
  },
  {
    order: 5,
    question: 'Alto made the details and requirements of my delivery clear.',
    required: false,
    response: null,
    type: 'numeric',
  },
  {
    order: 6,
    question: 'What can Alto improve?',
    required: false,
    response: null,
    type: 'text',
  },
];

type SurveyResponse = {
  name: string;
  data: string;
  uuid: string;
  version: number;
};

type Props = {
  readonly clearCreateSurveyResponseError: () => void;
  // eslint-disable-next-line import/no-deprecated
  readonly submitSurveyResponse: (response: SurveyResponse) => Promise<any>;
  readonly uuid: string;
};

type State = {
  step: number;
};

class SurveyPageContainer extends PureComponent<Props, State> {
  state = {
    step: 0,
  };

  // @ts-expect-error error TS1270: Decorator function return type 'void | TypedPropertyDescriptor<unknown>' is not assignable to type 'void | (() => void)'
  @autobind
  changeStep(direction?: string) {
    this.setState((prevState) => ({
      step: direction === 'back' ? prevState.step - 1 : prevState.step + 1,
    }));
  }

  // @ts-expect-error error TS1270: Decorator function return type 'void | TypedPropertyDescriptor<unknown>' is not assignable to type 'void | (() => void)'
  @autobind
  formatData(data: FormValues) {
    // @ts-expect-error TS(2345): Argument of type '(question: Question, i: number) => Question' is not assignable to parameter of typ... (Delete me to see the full error)
    return CES_QUESTIONS.map((question: Question, i) => {
      question.response = data[i];
      return question;
    });
  }

  // @ts-expect-error error TS1270: Decorator function return type 'void | TypedPropertyDescriptor<unknown>' is not assignable to type 'void | (() => void)'
  @autobind
  onSubmit(data: FormValues) {
    const { clearCreateSurveyResponseError, submitSurveyResponse, uuid } = this.props;

    clearCreateSurveyResponseError();

    const response: SurveyResponse = {
      name: 'ces',
      data: JSON.stringify(this.formatData(data)),
      uuid,
      version: 1,
    };

    submitSurveyResponse(response);
  }

  render() {
    const { step } = this.state;

    return (
      <SurveyPage
        // eslint-disable-next-line @typescript-eslint/unbound-method
        changeStep={this.changeStep}
        // eslint-disable-next-line @typescript-eslint/unbound-method
        onSubmit={this.onSubmit}
        // @ts-expect-error TS(2769): No overload matches this call.
        question={CES_QUESTIONS[step]}
        step={step}
        totalQuestions={CES_QUESTIONS.length}
      />
    );
  }
}

// @ts-expect-error TS(7006): Parameter 'state' implicitly has an 'any' type.
function mapStateToProps(state: ReduxStateShared, ownProps) {
  const { params } = ownProps;
  const { uuid } = params;

  return {
    uuid,
  };
}

const mapDispatchToProps = {
  clearCreateSurveyResponseError,
  // eslint-disable-next-line import/no-deprecated
  submitSurveyResponse,
};

// @ts-expect-error TS(2345): Argument of type 'typeof SurveyPageContainer' is not assignable to parameter of type 'ComponentType<... (Delete me to see the full error)
export default connect(mapStateToProps, mapDispatchToProps)(SurveyPageContainer);
